import { defineComponent as _defineComponent } from 'vue'
interface Props {
  answer: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqAnswer',
  props: {
    answer: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})